// extracted by mini-css-extract-plugin
export default {"spinner":"LoadedImage_spinner__SH+vr","spin":"LoadedImage_spin__HrluP"};